import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    salesVoucherApi,
    salesReturnVouchersApi,
    getTransactionHierarchyApi,
} from "../../apiservice/sales";

import {
    purchaseReturnVoucherApi,
} from "../../apiservice/purchase";
import { postData } from "../../apiservice/apis";


// ---------------------------------------------------------
// FETCH VOUCHERS
// ---------------------------------------------------------

export const fetchVoucherList = createAsyncThunk(
    "hierarchy/fetchVoucherList",
    async (referenceType, { rejectWithValue }) => {
        try {
            let response;

            switch (referenceType) {
                case "sales":
                    response = await salesVoucherApi({});
                    break;

                case "sales_return":
                    response = await salesReturnVouchersApi({});
                    break;

                case "purchase_return":
                    response = await purchaseReturnVoucherApi({});
                    break;

                default:
                    response = {
                        data: [],
                    };
            }

            return {
                referenceType,
                list: response.data || [],
            };

        } catch (err) {
            return rejectWithValue(
                err.response?.data || err.message
            );
        }
    }
);


// ---------------------------------------------------------
// FETCH HIERARCHY
// ---------------------------------------------------------

export const fetchHierarchy = createAsyncThunk(
    "hierarchy/fetchHierarchy",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await getTransactionHierarchyApi(payload);

            // The API now returns:
            // {
            //   hierarchy: [...], // Already built tree structure
            //   unlinkedSSCCs: [...],
            //   validation: {...},
            //   summary: {...}
            // }

            return {
                hierarchyTree: res.data.hierarchy || [],
                unlinkedSSCCs: res.data.unlinkedSSCCs || [],
                validation: res.data.validation || null,
                summary: res.data.summary || null
            };

        } catch (err) {
            return rejectWithValue(
                err.response?.data || err.message
            );
        }
    }
);


// frontend/src/pages/TatmeenHierarchy/hierarchyThunk.js

// Get SSCC Packing Details
export const fetchSSCCPackingDetails = createAsyncThunk(
    "hierarchy/fetchSSCCPackingDetails",
    async ({ reference_type, reference_id }, { rejectWithValue }) => {
        try {
            const response = await postData('/inventory/get-sscc-packing-details', {
                reference_type,
                reference_id
            });
            return response.data.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

// Trigger Packing
export const triggerPacking = createAsyncThunk(
    "hierarchy/triggerPacking",
    async ({ reference_type, reference_id, packing_type }, { rejectWithValue }) => {
        try {
            let url = '/inventory/process-packing';
            if (reference_type == 'sales') {
                url = '/inventory/process-sales-packing';
            }
            const response = await postData(`${url}`, {
                reference_type,
                reference_id,
                packing_type
            });
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);